import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { GetJobSearchAssistDocument } from 'src/graphql/graphql';
import { logger } from 'src/modules/logger';

import type { TypedThunkAction } from '../types';

import {
  GET_JOB_SEARCH_ASSIST_ERROR,
  GET_JOB_SEARCH_ASSIST_SUCCESS,
} from './types';

interface FetchJobSearchAssistArgs {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  tokens: string[];
}

export const fetchJobSearchAssist =
  ({ apolloClient, tokens }: FetchJobSearchAssistArgs): TypedThunkAction =>
  async (dispatch) => {
    try {
      const response = await apolloClient.query({
        context: {
          headers: {
            'x-custom-features': 'application/features.seek.all+json',
          },
        },
        query: GetJobSearchAssistDocument,
        variables: {
          tokens,
        },
        errorPolicy: 'all',
      });

      const jobSearchAssist = response?.data?.jobSearchAssist;
      const errors = response?.errors;

      if (errors && errors.length) {
        for (const error of errors) {
          if (!jobSearchAssist) {
            logger.error(
              { err: error, input: { tokens } },
              'JobSearchAssist GraphQL Error',
            );
          }

          logger.error(
            { err: error, input: { tokens } },
            'JobSearchAssist GraphQL Partial Failure',
          );
        }
      }

      dispatch({
        type: GET_JOB_SEARCH_ASSIST_SUCCESS,
        payload: {
          pills: jobSearchAssist?.pills?.data || [],
        },
      });
    } catch (error) {
      dispatch({
        type: GET_JOB_SEARCH_ASSIST_ERROR,
        payload: {
          error: error instanceof Error ? error.message : String(error),
        },
      });
    }
  };
